import axios from "axios";

/**
 * Requests user's orders
 * @param {string} sewperContactSeq
 * @returns {Promise<AxiosResponse<OrdersListItem[]>>}
 */
export function getOrders(sewperContactSeq) {
  return axios(`/sewp5public/orderapp/order/search/SCS/${sewperContactSeq}`);
}

/**
 * Requests order details for a given orderId
 * @param {number} orderId
 * @returns {Promise<AxiosResponse<OrderDetails>>}
 */
export function getOrderDetails(orderId) {
  return axios.get(`/sewp5public/orderapp/order/orderdetails/${orderId}`);
}

/**
 *
 * @returns {Promise<axios.AxiosResponse<OrdersUser>>}
 */
export function getOrderUser() {
  return axios.get("/sewp5public/orderapp/order/user");
}
